
export enum MediaType {
  ALL = 'all',
  PHOTO = 'photo',
  VIDEO = 'video'
}

export type MediaSource = 'drive' | 'dropbox' | 'local' | 'uploadthing';

export interface DriveFile {
  id: string;
  name: string;
  mimeType: string;
  thumbnailLink?: string; // Low res
  webContentLink?: string; // Download link (sometimes useful)
  webViewLink?: string; // Google Drive preview page
}

export interface DropboxFile {
  id: string;
  name: string;
  mimeType: string;
  directLink: string;
  thumbnailLink?: string;
}

// Unified interface for the app to use
export interface MediaItem {
  id: string;
  name: string;
  mimeType: string;
  source: MediaSource;
  collectionIds?: string[];
  contentHash?: string;
  sizeBytes?: number;
  originalSource?: 'drive' | 'dropbox' | 'local' | 'uploadthing';
  syncStatus?: 'syncing' | 'device-only' | 'synced';
  // Fields specific to Drive
  driveFile?: DriveFile;
  // Fields specific to Dropbox
  dropboxFile?: DropboxFile;
  // Fields specific to UploadThing
  uploadThingFile?: {
    key: string;
  };
  // Fields specific to Local
  file?: File; 
}

export interface AppSettings {
  filter: MediaType;
  interval: number; // Seconds per photo
  isPlaying: boolean;
  showInfo: boolean;
}

export interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSearch: (query: string) => void;
  isProcessing: boolean;
}

// Metadata storage types for persistent storage solution
export interface MediaMetadata {
  id: string;
  userId?: string;
  driveFileId?: string;
  localFileHash?: string;
  name: string;
  mimeType: string;
  fileSize?: number;
  source: MediaSource;
  indexedAt: string;
  lastModified?: string;
  createdTime?: string;
  tags?: string[];
  thumbnailUrl?: string;
  externalLink?: string;
  syncVersion?: number;
  deletedAt?: string;
}

export interface SyncState {
  userId?: string;
  lastDriveSyncToken?: string;
  lastDriveSyncTime?: string;
  totalDriveFilesIndexed: number;
  lastLocalSyncTime?: string;
  totalLocalFilesIndexed: number;
  lastFullSyncTime?: string;
  syncVersion: number;
}

export interface DriveAuthSession {
  accessToken: string;
  idToken?: string;
  expiresAt: number;
  userSub?: string;
  email?: string;
}

export interface AuthorizedMediaItem {
  fileId: string;
  name: string;
  mimeType: string;
  source?: 'drive' | 'dropbox' | 'local';
  externalLink?: string;
  thumbnailLink?: string;
  modifiedTime?: string;
  size?: string;
  sizeBytes?: number;
  contentHash?: string;
  originalSource?: 'drive' | 'dropbox' | 'local';
  addedAt: string;
  collectionIds?: string[];
}
